import styled from "styled-components";
import { colors } from "../../../themes/colors";

export const LoaderBackdrop = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999999999999999999999;

  @keyframes boat {
    0% {
      transform: rotate(0);
    }

    50% {
      transform: rotate(-3deg);
    }

    100% {
      transform: rotate(0);
    }
  }
  
  img {
    animation: boat 3s linear infinite;
  }

  #container {
    width: 600px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
  }

  .circle {
    border-radius: 50%;
    background-color: ${colors.background.kleinBlue};
    width: 150px;
    height: 150px;
    position: absolute;
    opacity: 0;
    animation: scaleIn 4s infinite cubic-bezier(.36, .11, .89, .32);
    :nth-of-type(2) {
      animation-delay: 1s;
    }
    :last-of-type {
      animation-delay: 2s;
    }
  }

  .item {
    z-index: 100;
    padding: 5px;
  }

  .item img {
    width: 150px;
  }

  @keyframes scaleIn {
    from {
      transform: scale(.5, .5);
      opacity: .5;
    }
    to {
      transform: scale(2.5, 2.5);
      opacity: 0;
    }
  }
`;
